import React from 'react';
import scaleSize from '../../utils/scale-size';
import styled from 'styled-components/macro';

const Svg = styled.svg`
  margin-bottom: -${scaleSize(10)}px;
`;

export default () => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 192 192"
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="#9F9F9F"
      strokeWidth="12"
      transform="translate(32 32)"
    >
      <path strokeLinecap="round" d="M88 88l32 32" />
      <circle cx="52" cy="52" r="46" />
    </g>
  </Svg>
);
